// src/components/spatial/config/drawSpaceConfig.js

const drawSpaceConfig = {
  /*
  ================================================================
  OUTILS DISPONIBLES DANS LA TOOLBAR
  ================================================================
  */
 tools: {
  SELECT: "select",
  MOVE: "move",
  COPY: "copy",
  DELETE: "delete",
  AREA_RECT: "area-rect",
  AREA_POLYLINE: "area-polyline",
  LINE: "line",
  CIRCLE: "circle",
  ARC: "arc",
  POINT: "point",
  INTERFACE_RECTANGLE: "interface-rectangle",
  PAN: "pan",
  ZOOM_IN: "zoom-in",
  ZOOM_OUT: "zoom-out",
  RESET_VIEW: "reset-view",
  PRINT: "print",
},


// ICONES TOOLS
icons: {
  INTERFACE_RECTANGLE: "../public/assets/icones/bell.svg",

},



  /*
  ================================================================
  TYPES TECHNIQUES D’ENTITÉS DESSINÉES
  ================================================================

  Important :
  - entityTypes = primitive géométrique
  - displayTypes = mode de rendu
  */
  entityTypes: {
    ASSET_ENVELOPE: "ASSET_ENVELOPE",
    AREA_RECT: "AREA_RECT",
    AREA_POLYLINE: "AREA_POLYLINE",
    LINE: "LINE",
    CIRCLE: "CIRCLE",
    ARC: "ARC",
    POINT: "POINT",
  },

  /*
  ================================================================
  MODES D’AFFICHAGE
  ================================================================
  */
  displayTypes: {
    SHAPE: "SHAPE",
    SYMBOL: "SYMBOL",
  },

  /*
  ================================================================
  CATÉGORIES MÉTIER MINIMALES
  ================================================================
  */
  entityCategories: {
    SPATIAL: "SPATIAL",
    NETWORK: "NETWORK",
    EQUIPMENT: "EQUIPMENT",
  },

  /*
  ================================================================
  MODES DE CRÉATION
  ================================================================
  */
  creationModes: {
    SUPPORT: "SUPPORT",
    NETWORK: "NETWORK",
    EQUIPMENT: "EQUIPMENT",
  },

  /*
  ================================================================
  HIÉRARCHIE SPATIALE
  ================================================================

  Important :
  - les modes réellement utilisés dans les composants actuels sont :
    SITE / OUVRAGE / NIVEAU
  - on garde CORRIDOR pour extension future
  */
  spatialHierarchy: {
    rootContexts: ["SITE", "CORRIDOR"],
    nestedContexts: ["OUVRAGE", "NIVEAU"],
    supportLevels: ["SITE", "OUVRAGE", "NIVEAU", "CORRIDOR"],
  },

  /*
  ================================================================
  TYPOLOGIES DE SUPPORTS SPATIAUX
  ================================================================
  */
  supportTypologies: {
    SITE_SUPPORT: "SITE_SUPPORT",
    ASSET_SUPPORT: "ASSET_SUPPORT",
    LEVEL_SURFACE: "LEVEL_SURFACE",
    FUNCTIONAL_AREA: "FUNCTIONAL_AREA",
    CORRIDOR_ZONE: "CORRIDOR_ZONE",
  },

  /*
  ================================================================
  DOMAINES D’ASSIGNEMENTS
  ================================================================
  */
  assignmentDomains: {
    BUILDING_SYSTEMS: "BUILDING_SYSTEMS",
    TECHNICAL_SYSTEMS: "TECHNICAL_SYSTEMS",
    CIVIL_SYSTEMS: "CIVIL_SYSTEMS",
  },

  /*
  ================================================================
  MAPPING DE CRÉATION PAR DÉFAUT
  ================================================================

  Ce bloc prépare la transition entre :
  - outils géométriques actuels
  - future UX orientée intention métier
  */
  defaultCreationMapping: {
    SUPPORT_RECT: {
      mode: "SUPPORT",
      entityCategory: "SPATIAL",
      typology: "LEVEL_SURFACE",
      geometryType: "AREA_RECT",
      displayType: "SHAPE",
    },

    SUPPORT_POLYLINE: {
      mode: "SUPPORT",
      entityCategory: "SPATIAL",
      typology: "FUNCTIONAL_AREA",
      geometryType: "AREA_POLYLINE",
      displayType: "SHAPE",
    },

    NETWORK_LINE: {
      mode: "NETWORK",
      entityCategory: "NETWORK",
      typology: "GENERIC_NETWORK",
      geometryType: "LINE",
      displayType: "SHAPE",
    },

    NETWORK_POLYLINE: {
      mode: "NETWORK",
      entityCategory: "NETWORK",
      typology: "GENERIC_NETWORK",
      geometryType: "AREA_POLYLINE",
      displayType: "SHAPE",
    },

    EQUIPMENT_POINT: {
      mode: "EQUIPMENT",
      entityCategory: "EQUIPMENT",
      typology: "GENERIC_EQUIPMENT",
      geometryType: "POINT",
      displayType: "SYMBOL",
    },
  },

  /*
  ================================================================
  PARAMÈTRES PAR DÉFAUT DU COMPOSANT
  ================================================================
  */
  defaults: {
    width: "100%",
    height: 780,

    showToolbar: true,
    showLevelBar: true,
    showPropertiesPanel: true,
    showGrid: true,

    enablePersistence: true,
    enablePrint: true,

    readOnlyMode: false,
    disabled: false,

    assetLabel: "Asset",
    printTitle: "Spatial Plan",
    printOrientation: "landscape",

    defaultLevelId: null,

    minZoom: 0.4,
    maxZoom: 4,
    zoomStep: 0.15,
    defaultZoom: 1,

    defaultOffsetX: 0,
    defaultOffsetY: 0,

    gridSize: 20,
    gridMinorFactor: 1,
    gridMajorEvery: 5,

    gridPresets: [
      { label: "1 m", value: 20 },
      { label: "0.5 m", value: 10 },
      { label: "0.1 m", value: 2 },
    ],

    defaultSnapToGrid: true,

    selectionStrokeWidth: 2,
    shapeStrokeWidth: 1.25,
    hitStrokeWidth: 10,
    handleSize: 8,

    defaultLevelLabel: "Ground Floor",
    defaultLevelElevation: 0,
    defaultPointRadius: 6,
  },

  /*
  ================================================================
  IMPRESSION
  ================================================================
  */
  print: {
    formats: {
      A4: "A4",
    },
    orientations: {
      PORTRAIT: "portrait",
      LANDSCAPE: "landscape",
    },
    defaultFormat: "A4",
    defaultOrientation: "landscape",
    pagePadding: 18,
  },

  /*
  ================================================================
  LIBELLÉS UI
  ================================================================
  */
  level: {
    defaultOrder: 1,
    emptyLabel: "No level loaded",
  },

  labels: {
    toolbar: "Tools",
    level: "Level",
    elevation: "Elevation",
    properties: "Properties",
    empty: "No drawing data",
    noSelection: "No selection",
  },

  /*
  ================================================================
  ENDPOINTS API
  ================================================================
  */
  api: {
    viewsEndpoint: "/api/spatial/views",
    entitiesEndpoint: "/api/spatial/entities",
  },

  /*
  ================================================================
  STYLES PAR DÉFAUT DES TYPES TECHNIQUES DE SHAPES
  ================================================================
  */
  shapeDefaults: {
    ASSET_ENVELOPE: { fillOpacity: 0.08 },
    AREA_RECT: { fillOpacity: 0.16 },
    AREA_POLYLINE: { fillOpacity: 0.16 },
    LINE: { fillOpacity: 0 },
    CIRCLE: { fillOpacity: 0.16 },
    ARC: { fillOpacity: 0 },
    POINT: { fillOpacity: 1 },
  },

  /*
  ================================================================
  PALETTES MÉTIER PAR NIVEAU DE RATTACHEMENT
  ================================================================

  Règles :
  - Site     -> bleu
  - Ouvrage  -> magenta
  - Niveau   -> orange / bronze
  - Emprise  -> gris foncé, sans remplissage
  */
  palettes: {
    site: {
      stroke: "#164D63",
      fill: "rgba(22,77,99,0.15)",
      previewFill: "rgba(22,77,99,0.08)",
      previewStroke: "#164D63",
      selectedStroke: "#164D63",
    },

    ouvrage: {
      stroke: "#A23B72",
      fill: "rgba(162,59,114,0.15)",
      previewFill: "rgba(162,59,114,0.08)",
      previewStroke: "#A23B72",
      selectedStroke: "#A23B72",
    },

    level: {
      stroke: "#B8621B",
      fill: "rgba(184,98,27,0.15)",
      previewFill: "rgba(184,98,27,0.08)",
      previewStroke: "#B8621B",
      selectedStroke: "#B8621B",
    },

    area: {
      stroke: "#1A8C74",
      fill: "rgba(26,140,116,0.15)",
      previewFill: "rgba(26,140,116,0.08)",
      previewStroke: "#1A8C74",
      selectedStroke: "#1A8C74",
    },

    siteEntity: {
      stroke: "#164D63",
      fill: "rgba(22,77,99,0.10)",
      previewFill: "rgba(22,77,99,0.06)",
      previewStroke: "#164D63",
      selectedStroke: "#164D63",
    },

    ouvrageEntity: {
      stroke: "#A23B72",
      fill: "rgba(162,59,114,0.10)",
      previewFill: "rgba(162,59,114,0.06)",
      previewStroke: "#A23B72",
      selectedStroke: "#A23B72",
    },

    levelEntity: {
      stroke: "#B8621B",
      fill: "rgba(184,98,27,0.10)",
      previewFill: "rgba(184,98,27,0.06)",
      previewStroke: "#B8621B",
      selectedStroke: "#B8621B",
    },

    siteEmprise: {
      stroke: "#4A4F57",
      fill: "rgba(74,79,87,0)",
      previewFill: "rgba(74,79,87,0)",
      previewStroke: "#4A4F57",
      selectedStroke: "#4A4F57",
    },

    ouvrageEmprise: {
      stroke: "#4A4F57",
      fill: "rgba(74,79,87,0)",
      previewFill: "rgba(74,79,87,0)",
      previewStroke: "#4A4F57",
      selectedStroke: "#4A4F57",
    },

    levelEmprise: {
      stroke: "#4A4F57",
      fill: "rgba(74,79,87,0)",
      previewFill: "rgba(74,79,87,0)",
      previewStroke: "#4A4F57",
      selectedStroke: "#4A4F57",
    },

    point: {
      stroke: "#164D63",
      fill: "#164D63",
      previewFill: "rgba(22,77,99,0.20)",
      previewStroke: "#164D63",
      selectedStroke: "#B8621B",
    },
  },
};

export default drawSpaceConfig;